import React from "react";
import "../styles/reviews.css";

const reviewsData = [
  {
    name: "Fehér István",
    title: "Villanyszerelő",
    text: "„Tamás az egyik legügyesebb marketinges akivel eddig találkoztam. Megbízható,segítőkész. Amióta Ő kezeli a hirdetéseimet azóta úgy érzem sínen van a vállalkozásom. Sokkal több hívást kapok és több az online megkeresésem is az ügyfelek részéről. A Feleségem és az Én vállalkozásom hirdetéseit is ő kezeli. Mindketten elégedettek vagyunk a munkájával. Csak ajánlani tudom.”",
    image: "/images/fp.jpeg",
    link: "https://szolnokivillanyszerelo.hu",
  },
  {
    name: "Molnár László",
    title: "Guri Sörbisztró Szolnok",
    text: "„Tomi segített a Google cégem profilunk beállításaiban és igazolásában, azóta elsőként találnak meg a keresőben.”",
    image: "/images/guri.jpg",
    link: "https://share.google/XpvyA48tdaHPsaBIB",
  },
  {
    name: "Zolnai Armand",
    title: "Duguláselhárítás",
    text: "„Amióta Tomi kezeli az online hirdetéseinket és a weboldalunkat, sokkal több hívást és megkeresést kapunk Szolnokról és a környékről. A weboldalunk folyamatosan az első helyek között jelenik meg a Google-ben.”",
    image: "/images/za.webp",
    link: "https://szolnokdugulaselharitas.hu/",
  },
  {
    name: "Czékmány Norbi",
    title: "Hello Cuki - Kápolna",
    text: "„Tökéletesen elégedett vagyok a közös munkával. Szépen növekszik az elérésünk, és az új elképzelések megvalósításában is igazi partner Tamás. Az egyeztetések gördülékenyek, ami nagyban megkönnyíti a folyamatokat és a tervezést. Az eddig tapasztaltak alapján hosszú távon számítok az együttműködésre.”",
    image: "/images/hc.jpg",
    link: "https://share.google/TzZ7i0qrtEPmPUMJC",
  },
];

function Reviews() {
  return (
    <section className="reviews p-2">
      <div className="container py-5">
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="text-center mb-2">
              <h2 className="section-title">
                Ügyfeleim sikerei önmagukért beszélnek
              </h2>
              <p className="section-subtitle">
                Nézd meg, hogyan segítettem kisvállalkozásoknak növekedni az
                online hirdetések erejével.
              </p>
            </div>
            <div className="text-center mb-4 pb-2">
              <i className="fas fa-quote-left fa-3x text-white"></i>
            </div>

            <div className="card-reviews shadow">
              <div className="card-body-reviews  py-5">
                <div
                  id="testimonialCarousel"
                  className="carousel slide carousel-dark"
                  data-bs-ride="carousel"
                >
                  {/* Indicators */}
                  <div className="carousel-indicators mb-0">
                    {reviewsData.map((_, index) => (
                      <button
                        key={index}
                        type="button"
                        data-bs-target="#testimonialCarousel"
                        data-bs-slide-to={index}
                        className={index === 0 ? "active" : ""}
                        aria-current={index === 0 ? "true" : undefined}
                        aria-label={`Slide ${index + 1}`}
                      ></button>
                    ))}
                  </div>

                  {/* Slides */}
                  <div className="carousel-inner pb-5">
                    {reviewsData.map((review, index) => (
                      <div
                        className={`carousel-item ${
                          index === 0 ? "active" : ""
                        }`}
                        key={index}
                      >
                        <div className="row justify-content-center">
                          <div className="col-lg-10 col-xl-8">
                            <div className="row">
                              <div className="col-lg-4 d-flex justify-content-center align-items-center">
                                <img
                                  src={review.image}
                                  alt={review.name}
                                  className="rounded-circle shadow mb-4 mb-lg-0"
                                  width="190"
                                  height="190"
                                />
                              </div>
                              <div className="col-lg-8 d-flex flex-column justify-content-center text-center text-lg-start">
                                <h5 className="mb-3">
                                  {review.name} – {review.title}
                                </h5>
                                <p className="mb-1 review-text">
                                  {review.text}
                                </p>
                                {review.link ? (
                                  <a
                                    href={review.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="review-link"
                                  >
                                    {(() => {
                                      const hostname = new URL(
                                        review.link
                                      ).hostname.replace("www.", "");
                                      return hostname.includes("google")
                                        ? review.title
                                        : hostname;
                                    })()}
                                  </a>
                                ) : (
                                  <span className="review-link"></span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#testimonialCarousel"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Előző</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#testimonialCarousel"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Következő</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="text-center mt-4 pt-2">
              <i className="fas fa-quote-right fa-3x text-white"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Reviews;
